// libs
import React from 'react';
import { mergeWith } from 'lodash';

import { cn } from '@lyearn/style';
// components
import { DialogComponent } from '@/components/DialogComponent';
import { DIALOG_PAPER_CLASSES } from '@/components/DialogComponent/style';

// types
import { ModalProps } from '../types';
import Content from './components/Content';
import DialogBody from './components/Dialog';
import List from './components/List';
import { dialogSizeStyles } from './style';
import { IComposition } from './types';

export const dialogClasses = {
  paper: DIALOG_PAPER_CLASSES,
};

const CLOSE_BUTTON_PROPS = {
  size: 'small' as const,
  className: 'mt-8 me-8',
};

/**
 * @deprecated use AlertDialog instead
 */
const Dialog: React.FC<ModalProps> & IComposition = (props) => {
  const {
    classes = {
      // default height classes of dialog
      paper: dialogSizeStyles,
    },
    onClose,
    open = true,
    closeButton = CLOSE_BUTTON_PROPS,
    showCloseIcon,
  } = props;

  const mergedClasses = React.useMemo(() => mergeWith({}, dialogClasses, classes, cn), [classes]);

  return (
    <DialogComponent
      classes={mergedClasses}
      closeButton={closeButton}
      open={open}
      showCloseIcon={showCloseIcon}
      onClose={onClose}>
      <DialogBody {...props} />
    </DialogComponent>
  );
};

Dialog.Content = Content;
Dialog.List = List;

export default Dialog;
